import images from "./gallery";

const Gallery = () => <pre>{JSON.stringify(images, null, 2)}</pre>;

export default Gallery;
